// @ts-nocheck
// This file is auto-generated by GraphQL Code Generator

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AiAudit = {
  __typename?: 'AiAudit';
  /** When the audit row was created */
  createdAt: Scalars['DateTime']['output'];
  /** OpenAI request pathname (e.g. /v1/chat/completions) */
  endpoint: Scalars['String']['output'];
  /** CUID of the audit row */
  id: Scalars['String']['output'];
  /** Serialized OpenAI request parameters (body, etc.) */
  input: Scalars['JSON']['output'];
  /** Correlates audit rows from one executeProcessor run (from metadata.instanceId) */
  instanceId?: Maybe<Scalars['String']['output']>;
  /** Iteration index when provided (from metadata.iteration) */
  iteration?: Maybe<Scalars['Int']['output']>;
  /** Max iterations when provided (from metadata.maxIterations) */
  maxIterations?: Maybe<Scalars['Int']['output']>;
  /** Normalized request metadata snapshot (prompt, instanceId, model, …) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Model id when provided (from metadata.model) */
  model?: Maybe<Scalars['String']['output']>;
  /** Parsed OpenAI response body or error envelope */
  output: Scalars['JSON']['output'];
  /** Application prompt slug when provided (from metadata.prompt) */
  prompt?: Maybe<Scalars['String']['output']>;
};

export type AiAuditFilterOptions = {
  __typename?: 'AiAuditFilterOptions';
  /** Distinct OpenAI API pathnames (e.g. /v1/chat/completions) */
  endpoints: Array<Scalars['String']['output']>;
  /** Distinct non-null audit prompt slugs (metadata.prompt) */
  prompts: Array<Scalars['String']['output']>;
};

export type AiAuditSummary = {
  __typename?: 'AiAuditSummary';
  /** When the audit row was created */
  createdAt: Scalars['DateTime']['output'];
  /** OpenAI request pathname (e.g. /v1/chat/completions) */
  endpoint: Scalars['String']['output'];
  /** CUID of the audit row */
  id: Scalars['String']['output'];
  /** Correlates audit rows from one executeProcessor run (from metadata.instanceId) */
  instanceId?: Maybe<Scalars['String']['output']>;
  /** Iteration index when provided (from metadata.iteration) */
  iteration?: Maybe<Scalars['Int']['output']>;
  /** Max iterations when provided (from metadata.maxIterations) */
  maxIterations?: Maybe<Scalars['Int']['output']>;
  /** Normalized request metadata snapshot (prompt, instanceId, model, …) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Model id when provided (from metadata.model) */
  model?: Maybe<Scalars['String']['output']>;
  /** Application prompt slug when provided (from metadata.prompt) */
  prompt?: Maybe<Scalars['String']['output']>;
};

export type AppSettings = {
  __typename?: 'AppSettings';
  /** OpenAI model IDs allowed for document AI edit (executeProcessor variables.model). */
  aiAssistEditChatModels: Array<Scalars['String']['output']>;
  /** Default OpenAI model for document AI edit when variables.model is omitted or invalid. */
  defaultAiAssistEditChatModel: Scalars['String']['output'];
  /** Regex pattern for valid document paths (lowercase a-z, digits, /, -, (, )) */
  documentPathRegex: Scalars['String']['output'];
  localDatabase?: Maybe<Scalars['Boolean']['output']>;
  localEndpoints?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  /** Logged-in user */
  user: AuthUser;
};

export type AuthUser = {
  __typename?: 'AuthUser';
  /** User display name */
  displayName: Scalars['String']['output'];
  /** Resolved model id: user preference when valid, else deployment default. */
  effectiveAiAssistEditChatModel: Scalars['String']['output'];
  /** User email */
  email: Scalars['String']['output'];
  /** User ID */
  id: Scalars['String']['output'];
  /** Persisted JSON settings (subset exposed here) */
  settings?: Maybe<UserSettings>;
};

export type CreateAiThreadReplyInput = {
  /** Optional ProcessorInstance id to attach as message context (must belong to current user) */
  processorInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Thread root message ID */
  rootMessageId: Scalars['String']['input'];
  /** Assistant reply body */
  value: Scalars['String']['input'];
};

export type CreateMessageInput = {
  /** Context key-value pairs to attach to the message */
  contexts?: InputMaybe<Array<MessageContextInput>>;
  /** Parent message ID for threading */
  parentMessageId?: InputMaybe<Scalars['String']['input']>;
  /** Content of the message */
  value: Scalars['String']['input'];
};

export type DeleteMessageInput = {
  /** ID of the message to soft-delete */
  id: Scalars['String']['input'];
};

export type DeletePromptInput = {
  /** ID of the prompt to delete */
  id: Scalars['String']['input'];
};

export type DeletePromptResponse = {
  __typename?: 'DeletePromptResponse';
  /** Response message */
  message: Scalars['String']['output'];
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

export type Document = {
  __typename?: 'Document';
  /** Child documents whose path starts with this document path (paginated, sorted alphabetically) */
  children: DocumentChildrenResponse;
  /** Context of the document */
  context?: Maybe<Scalars['String']['output']>;
  /** When the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** History of changes to this document */
  documentHistory: Array<DocumentHistory>;
  /** Format of the document */
  format?: Maybe<Scalars['String']['output']>;
  /** Format validation information for the document */
  formatValidation?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the document (random ID) */
  id: Scalars['String']['output'];
  /** Closest parent document: the document whose path is the longest prefix of this document path (e.g. for path "a/b/c" returns document at "a/b" if it exists, else "a") */
  parent?: Maybe<Document>;
  /** Path/name of the document (used for lookups) */
  path: Scalars['String']['output'];
  /** When the document was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User ID who created the document */
  userId: Scalars['String']['output'];
  /** Content of the document */
  value: Scalars['String']['output'];
};


export type DocumentChildrenArgs = {
  input?: InputMaybe<DocumentChildrenPaginationInput>;
};

export type DocumentChildrenPaginationInput = {
  /** Cursor for pagination (path of last item from previous page) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of child documents to return (default: 5) */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentChildrenResponse = {
  __typename?: 'DocumentChildrenResponse';
  /** Child documents whose path starts with the parent path */
  items: Array<Document>;
  /** Pagination metadata */
  pagination: PaginationInfo;
};

export type DocumentHistory = {
  __typename?: 'DocumentHistory';
  /** When the revision was created */
  createdAt: Scalars['DateTime']['output'];
  /** The document this revision belongs to */
  document?: Maybe<Document>;
  /** Document ID this revision belongs to */
  documentId: Scalars['String']['output'];
  /** Unique identifier for the document history entry */
  id: Scalars['String']['output'];
  /** JSON value containing the full document record (excluding id, createdAt, updatedAt) and source information. Structure: { value: { userId: string, context: string | null, value: string, format: string | null, formatValidation: string | null }, source: [{ type: string, id: string }] } */
  value: Scalars['JSON']['output'];
};

export type DocumentNotFound = {
  __typename?: 'DocumentNotFound';
  /** Child documents whose path starts with this path (same as Document.children) */
  children: DocumentChildrenResponse;
  /** Closest parent document whose path is a prefix of this path (same as Document.parent) */
  parent?: Maybe<Document>;
  /** The path that was requested but no document exists (e.g. from documentByPath); null when resolved from document(id) not found */
  path?: Maybe<Scalars['String']['output']>;
};


export type DocumentNotFoundChildrenArgs = {
  input?: InputMaybe<DocumentChildrenPaginationInput>;
};

export type DocumentResult = Document | DocumentNotFound;

export type ExecuteProcessorInput = {
  /** ID of the processor to run */
  processorId: Scalars['String']['input'];
  /** Deferred run only: reuse this ProcessorInstance row (created by queueExecuteProcessor with isActive false until execution starts). */
  processorInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Map of input variables passed to the processor as ctx.variables */
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type ExecuteProcessorResponse = {
  __typename?: 'ExecuteProcessorResponse';
  /** Error message when success is false */
  error?: Maybe<Scalars['String']['output']>;
  /** Id of the ProcessorInstance row for this run (present when a row was created, including on failure) */
  instanceId?: Maybe<Scalars['String']['output']>;
  /** JSON result from the processor when success is true */
  result?: Maybe<Scalars['JSON']['output']>;
  /** Whether the execution succeeded */
  success: Scalars['Boolean']['output'];
};

export type GeneratePromptTemplateInput = {
  /** Optional document ID for context */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Optional message ID for context */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /** Prompt ID to use as template string */
  promptId: Scalars['String']['input'];
};

export type GeneratePromptTemplatesInput = {
  /** Array of prompt template inputs to process */
  templates: Array<GeneratePromptTemplateInput>;
};

export type GenerateTemplateInput = {
  /** Optional document ID for context */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Optional message ID for context */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /** Template string to render */
  templateString: Scalars['String']['input'];
};

export type GenerateTemplateResponse = {
  __typename?: 'GenerateTemplateResponse';
  /** Error message if template generation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Generated template result */
  result: Scalars['String']['output'];
  /** Whether the template generation was successful */
  success: Scalars['Boolean']['output'];
};

export type GenerateTemplatesInput = {
  /** Array of template inputs to process */
  templates: Array<GenerateTemplateInput>;
};

export type GenerateTemplatesResponse = {
  __typename?: 'GenerateTemplatesResponse';
  /** Array of template generation results */
  results: Array<GenerateTemplateResponse>;
};

export type GetProcessorsResponse = {
  __typename?: 'GetProcessorsResponse';
  /** List of processors */
  processors: Array<Processor>;
};

export type GetPromptsResponse = {
  __typename?: 'GetPromptsResponse';
  /** List of prompt definitions */
  prompts: Array<PromptDefinition>;
};

export type LoginInput = {
  /** User email */
  email: Scalars['String']['input'];
  /** Password */
  password: Scalars['String']['input'];
};

export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /** Whether logout succeeded */
  success: Scalars['Boolean']['output'];
};

export type Message = {
  __typename?: 'Message';
  /** Author of the message (subquery User for display name) */
  author: MessageAuthor;
  /** Child messages (replies) under this message */
  childMessages: Array<Message>;
  /** When the message was created */
  createdAt: Scalars['DateTime']['output'];
  /** When the message was soft-deleted; null if still visible */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the message */
  id: Scalars['String']['output'];
  /** Context data associated with this message */
  messageContexts: Array<MessageContext>;
  /** Parent message ID for threading */
  parentMessageId?: Maybe<Scalars['String']['output']>;
  /** Source type of the message (audio, message, etc.) */
  source: Scalars['String']['output'];
  /** Optional source ID for the message */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** User ID the message is targeted at */
  targetUserId: Scalars['String']['output'];
  /** When the message was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User ID who created the message */
  userId: Scalars['String']['output'];
  /** Content of the message */
  value: Scalars['String']['output'];
};

export type MessageAuthor = {
  __typename?: 'MessageAuthor';
  /** Display name of the message author */
  displayName: Scalars['String']['output'];
  /** MD5 hex digest of the author email (trimmed, lowercased) for Gravatar URLs, or the literal "system" for the built-in system user (clients may substitute app branding) */
  gravatarHash: Scalars['String']['output'];
};

export type MessageContext = {
  __typename?: 'MessageContext';
  /** Resolved document when name is "documentId"; null otherwise */
  document?: Maybe<Document>;
  /** Message ID this context belongs to */
  messageId: Scalars['String']['output'];
  /** Name of the context */
  name: Scalars['String']['output'];
  /** Resolved processor run when name is "processorInstanceId"; null otherwise */
  processorInstance?: Maybe<ProcessorInstance>;
  /** Value of the context */
  value: Scalars['String']['output'];
};

export type MessageContextInput = {
  /** Name of the context */
  name: Scalars['String']['input'];
  /** Value of the context */
  value: Scalars['String']['input'];
};

export type MessagesQueryInput = {
  /** Return only messages that have ALL matching context name/value pairs */
  contextFilters?: InputMaybe<Array<MessageContextInput>>;
  /** Start date for filtering messages (inclusive) */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** End date for filtering messages (inclusive) */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAiThreadReply: Message;
  createMessage: Message;
  deleteMessage: Message;
  deletePrompt: DeletePromptResponse;
  executeProcessor: ExecuteProcessorResponse;
  generatePromptTemplates: GenerateTemplatesResponse;
  generateTemplates: GenerateTemplatesResponse;
  /** Login with email and password. Sets an httpOnly cookie with JWT. */
  login: AuthPayload;
  /** Clear the auth cookie (logout). */
  logout: LogoutPayload;
  processPrompt: ProcessPromptResponse;
  processPromptFromMessage: ProcessPromptResponse;
  /** Queue executeProcessor for asynchronous HTTP execution (Cloud Tasks or GRAPHQL_TASK_SIMULATOR_URL). The caller JWT is sent on the deferred request. */
  queueExecuteProcessor: QueueExecuteProcessorResponse;
  /** Exchange refresh cookie for a new access JWT. No auth required. Rotates refresh token. */
  refreshAccessToken: AuthPayload;
  /** Register with email and password. Auto-logs in and sets cookie. */
  register: AuthPayload;
  transcribeAudio: TranscribeAudioResponse;
  /** Merge and persist the current user JSON settings (e.g. AI model). */
  updateMyUserSettings: AuthUser;
  /** Update current user profile fields (e.g. display name). */
  updateUserProfile: AuthUser;
  upsertDocument: UpsertDocumentResponse;
  upsertProcessor: UpsertProcessorResponse;
  upsertPrompt: UpsertPromptResponse;
};


export type MutationCreateAiThreadReplyArgs = {
  input: CreateAiThreadReplyInput;
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationDeleteMessageArgs = {
  input: DeleteMessageInput;
};


export type MutationDeletePromptArgs = {
  input: DeletePromptInput;
};


export type MutationExecuteProcessorArgs = {
  input: ExecuteProcessorInput;
};


export type MutationGeneratePromptTemplatesArgs = {
  input: GeneratePromptTemplatesInput;
};


export type MutationGenerateTemplatesArgs = {
  input: GenerateTemplatesInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationProcessPromptArgs = {
  input: ProcessPromptInput;
};


export type MutationProcessPromptFromMessageArgs = {
  input: ProcessPromptFromMessageInput;
};


export type MutationQueueExecuteProcessorArgs = {
  input: ExecuteProcessorInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationTranscribeAudioArgs = {
  input: TranscribeAudioInput;
};


export type MutationUpdateMyUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpsertDocumentArgs = {
  input: UpsertDocumentInput;
};


export type MutationUpsertProcessorArgs = {
  input: UpsertProcessorInput;
};


export type MutationUpsertPromptArgs = {
  input: UpsertPromptInput;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  /** Whether there are more items available */
  hasMore: Scalars['Boolean']['output'];
  /** Cursor for the next page (null if no more items) */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Total count of items (optional, can be expensive to compute) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProcessPromptContentItemInput = {
  /** Prompt name for prompt type */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Template options (e.g. documentId, messageId). Passed as context to the template. */
  options?: InputMaybe<Scalars['JSON']['input']>;
  /** Type of content item */
  type: Scalars['String']['input'];
  /** String value for string type */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessPromptFromMessageInput = {
  /** Whether this is a dry run (no actual processing) */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the message to process */
  messageId: Scalars['String']['input'];
};

export type ProcessPromptInput = {
  /** Array of content items to process */
  content: Array<ProcessPromptContentItemInput>;
};

export type ProcessPromptResponse = {
  __typename?: 'ProcessPromptResponse';
  /** Error message if any */
  error?: Maybe<Scalars['String']['output']>;
  /** Response message */
  message: Scalars['String']['output'];
  /** Generated response */
  response?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type Processor = {
  __typename?: 'Processor';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the ProcessorFile that holds the main script (and any prepended files via ProcessorFileMap) */
  fileId: Scalars['String']['output'];
  /** Machine-readable identifier */
  id: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProcessorDetail = {
  __typename?: 'ProcessorDetail';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the ProcessorFile that holds the main script (prepended files map to this parent) */
  fileId: Scalars['String']['output'];
  /** Ordered file segments for this processor (no source text; load code per file via processorFile) */
  fileRefs: Array<ProcessorFileRef>;
  /** Machine-readable identifier */
  id: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProcessorFileContent = {
  __typename?: 'ProcessorFileContent';
  /** Source text stored for this file */
  code: Scalars['String']['output'];
  /** ProcessorFile id */
  id: Scalars['String']['output'];
};

export type ProcessorFileRef = {
  __typename?: 'ProcessorFileRef';
  /** ProcessorFile id */
  id: Scalars['String']['output'];
  /** Prepended fragment vs main script file */
  role: ProcessorFileRole;
  /** Order key: lower prepended files run first; main segment is last */
  sortOrder: Scalars['Int']['output'];
};

export enum ProcessorFileRole {
  Main = 'MAIN',
  Prepended = 'PREPENDED'
}

export type ProcessorInstance = {
  __typename?: 'ProcessorInstance';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Error message when the run failed */
  error?: Maybe<Scalars['String']['output']>;
  /** CUID of the processor run row */
  id: Scalars['String']['output'];
  /** True while the run is in progress; false when finished */
  isActive: Scalars['Boolean']['output'];
  /** Processor id that was executed */
  processorId: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Owning user id */
  userId: Scalars['String']['output'];
  /** JSON result after successful completion */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type PromptDefinition = {
  __typename?: 'PromptDefinition';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Name/identifier of the prompt */
  id: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Content of the prompt */
  value: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Full AI audit row by id, or null if not found */
  aiAudit?: Maybe<AiAudit>;
  /** Distinct endpoint and metadata.prompt values for AI audit filters */
  aiAuditFilterOptions: AiAuditFilterOptions;
  /** Recent AI audit rows (newest first); optional filters on endpoint and prompt */
  aiAudits: Array<AiAuditSummary>;
  /** Application settings (e.g. validation patterns for the client) */
  appSettings: AppSettings;
  document: DocumentResult;
  documentByPath: DocumentResult;
  documentHistory?: Maybe<DocumentHistory>;
  documents: Array<Document>;
  /** Current user from JWT cookie. Returns null if not authenticated. */
  me?: Maybe<AuthUser>;
  messages: Array<Message>;
  processor?: Maybe<ProcessorDetail>;
  processorFile?: Maybe<ProcessorFileContent>;
  /** Processor run row by id for the current user, or null if not found */
  processorInstance?: Maybe<ProcessorInstance>;
  processors: GetProcessorsResponse;
  prompts: GetPromptsResponse;
  /** Recent uploads for the signed-in user (newest first), from POST /api/upload */
  uploads: Array<UserUpload>;
};


export type QueryAiAuditArgs = {
  id: Scalars['String']['input'];
};


export type QueryAiAuditsArgs = {
  endpoint?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocumentByPathArgs = {
  path: Scalars['String']['input'];
};


export type QueryDocumentHistoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocumentsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessagesArgs = {
  input?: InputMaybe<MessagesQueryInput>;
};


export type QueryProcessorArgs = {
  id: Scalars['String']['input'];
};


export type QueryProcessorFileArgs = {
  id: Scalars['String']['input'];
};


export type QueryProcessorInstanceArgs = {
  id: Scalars['String']['input'];
};


export type QueryUploadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueueExecuteProcessorResponse = {
  __typename?: 'QueueExecuteProcessorResponse';
  /** Human-readable detail (e.g. missing Bearer token, or error message when queued is false) */
  message?: Maybe<Scalars['String']['output']>;
  /** ProcessorInstance id for this queued run (pending until the worker executes) */
  processorInstanceId?: Maybe<Scalars['String']['output']>;
  /** Whether the task was queued (Cloud Tasks or local HTTP simulator when GRAPHQL_TASK_SIMULATOR_URL is set) */
  queued: Scalars['Boolean']['output'];
  /** Cloud Task resource name, or task id from GRAPHQL_TASK_SIMULATOR_URL */
  taskName?: Maybe<Scalars['String']['output']>;
};

export type RegisterInput = {
  /** User email */
  email: Scalars['String']['input'];
  /** Password (min 8 characters) */
  password: Scalars['String']['input'];
};

export type TranscribeAudioInput = {
  /** Array of file names to transcribe */
  fileNames: Array<Scalars['String']['input']>;
};

export type TranscribeAudioResponse = {
  __typename?: 'TranscribeAudioResponse';
  /** Number of files that failed transcription */
  failureCount: Scalars['Float']['output'];
  /** Response message */
  message: Scalars['String']['output'];
  /** Results for each file processed */
  results: Array<TranscribeResult>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Number of files successfully transcribed */
  successCount: Scalars['Float']['output'];
};

export type TranscribeResult = {
  __typename?: 'TranscribeResult';
  /** Error message if failed */
  error?: Maybe<Scalars['String']['output']>;
  /** File name that was processed */
  fileName: Scalars['String']['output'];
  /** File path that was processed */
  filePath: Scalars['String']['output'];
  /** Whether transcription was successful */
  success: Scalars['Boolean']['output'];
  /** Transcription content if successful */
  transcription?: Maybe<Scalars['String']['output']>;
};

export type UpdateUserProfileInput = {
  /** Display name shown in the UI */
  displayName: Scalars['String']['input'];
};

export type UpdateUserSettingsInput = {
  /** Set preferred AI model id, or null to clear and use deployment default */
  aiAssistEditChatModel?: InputMaybe<Scalars['String']['input']>;
  /** Set light or dark theme, or null to clear (default light) */
  colorMode?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDocumentInput = {
  /** Context of the document (optional for updates) */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Format of the document (optional for updates) */
  format?: InputMaybe<Scalars['String']['input']>;
  /** Format validation information for the document */
  formatValidation?: InputMaybe<Scalars['String']['input']>;
  /** ID of the document (cuid) - used for lookups and updates */
  id: Scalars['String']['input'];
  /** Path/name of the document (globally unique, required for new documents) */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Source ID for linking to messages or other entities */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Source type that caused this change (e.g., "user", "message") */
  sourceType?: InputMaybe<Scalars['String']['input']>;
  /** Content of the document (optional for updates) */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDocumentResponse = {
  __typename?: 'UpsertDocumentResponse';
  /** The upserted document */
  document: Document;
  /** Whether the document was created (true) or updated (false) */
  wasCreated: Scalars['Boolean']['output'];
};

export type UpsertProcessorInput = {
  /** ID of the ProcessorFile to run (must exist) */
  fileId: Scalars['String']['input'];
  /** Machine-readable identifier (no default) */
  id: Scalars['String']['input'];
};

export type UpsertProcessorResponse = {
  __typename?: 'UpsertProcessorResponse';
  /** Response message */
  message: Scalars['String']['output'];
  /** The upserted processor */
  processor: Processor;
};

export type UpsertPromptInput = {
  /** ID/name of the prompt */
  id: Scalars['String']['input'];
  /** Content of the prompt */
  value: Scalars['String']['input'];
};

export type UpsertPromptResponse = {
  __typename?: 'UpsertPromptResponse';
  /** Response message */
  message: Scalars['String']['output'];
  /** The upserted prompt definition */
  promptDefinition: PromptDefinition;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  /** Preferred OpenAI chat model for document AI (executeProcessor); must be in appSettings.aiAssistEditChatModels when set. */
  aiAssistEditChatModel?: Maybe<Scalars['String']['output']>;
  /** Light or dark UI theme; null means default (light). */
  colorMode?: Maybe<Scalars['String']['output']>;
};

/** A file uploaded via POST /api/upload for the current user */
export type UserUpload = {
  __typename?: 'UserUpload';
  createdAt: Scalars['DateTime']['output'];
  /** Original filename from the upload */
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Object key in the user-assets bucket (userId/uuid.ext) */
  resourceId: Scalars['String']['output'];
  /** HTTPS URL to fetch the uploaded object */
  url: Scalars['String']['output'];
};

export type MessageFieldsFragment = { __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null, processorInstance?: { __typename?: 'ProcessorInstance', id: string } | null }> };

export type CreateAiThreadReplyMutationVariables = Exact<{
  input: CreateAiThreadReplyInput;
}>;


export type CreateAiThreadReplyMutation = { __typename?: 'Mutation', createAiThreadReply: { __typename?: 'Message', id: string } };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, childMessages: Array<{ __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null, processorInstance?: { __typename?: 'ProcessorInstance', id: string } | null }> }>, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null, processorInstance?: { __typename?: 'ProcessorInstance', id: string } | null }> } };

export type DeleteMessageMutationVariables = Exact<{
  input: DeleteMessageInput;
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage: { __typename?: 'Message', id: string } };

export type DeletePromptMutationVariables = Exact<{
  input: DeletePromptInput;
}>;


export type DeletePromptMutation = { __typename?: 'Mutation', deletePrompt: { __typename?: 'DeletePromptResponse', message: string, success: boolean } };

export type ExecuteProcessorMutationVariables = Exact<{
  input: ExecuteProcessorInput;
}>;


export type ExecuteProcessorMutation = { __typename?: 'Mutation', executeProcessor: { __typename?: 'ExecuteProcessorResponse', success: boolean, error?: string | null, result?: any | null, instanceId?: string | null } };

export type GeneratePromptTemplatesMutationVariables = Exact<{
  input: GeneratePromptTemplatesInput;
}>;


export type GeneratePromptTemplatesMutation = { __typename?: 'Mutation', generatePromptTemplates: { __typename?: 'GenerateTemplatesResponse', results: Array<{ __typename?: 'GenerateTemplateResponse', result: string, success: boolean, error?: string | null }> } };

export type GenerateTemplatesMutationVariables = Exact<{
  input: GenerateTemplatesInput;
}>;


export type GenerateTemplatesMutation = { __typename?: 'Mutation', generateTemplates: { __typename?: 'GenerateTemplatesResponse', results: Array<{ __typename?: 'GenerateTemplateResponse', result: string, success: boolean, error?: string | null }> } };

export type RefreshAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshAccessTokenMutation = { __typename?: 'Mutation', refreshAccessToken: { __typename?: 'AuthPayload', user: { __typename?: 'AuthUser', id: string, email: string } } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', user: { __typename?: 'AuthUser', id: string, email: string } } };

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthPayload', user: { __typename?: 'AuthUser', id: string, email: string } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutPayload', success: boolean } };

export type ProcessPromptMutationVariables = Exact<{
  input: ProcessPromptInput;
}>;


export type ProcessPromptMutation = { __typename?: 'Mutation', processPrompt: { __typename?: 'ProcessPromptResponse', success: boolean, message: string, response?: string | null, error?: string | null } };

export type QueueExecuteProcessorMutationVariables = Exact<{
  input: ExecuteProcessorInput;
}>;


export type QueueExecuteProcessorMutation = { __typename?: 'Mutation', queueExecuteProcessor: { __typename?: 'QueueExecuteProcessorResponse', queued: boolean, message?: string | null, taskName?: string | null, processorInstanceId?: string | null } };

export type UpdateMyUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateMyUserSettingsMutation = { __typename?: 'Mutation', updateMyUserSettings: { __typename?: 'AuthUser', id: string, email: string, effectiveAiAssistEditChatModel: string, settings?: { __typename?: 'UserSettings', aiAssistEditChatModel?: string | null, colorMode?: string | null } | null } };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'AuthUser', id: string, email: string, displayName: string, effectiveAiAssistEditChatModel: string, settings?: { __typename?: 'UserSettings', aiAssistEditChatModel?: string | null, colorMode?: string | null } | null } };

export type UpsertDocumentMutationVariables = Exact<{
  input: UpsertDocumentInput;
}>;


export type UpsertDocumentMutation = { __typename?: 'Mutation', upsertDocument: { __typename?: 'UpsertDocumentResponse', wasCreated: boolean, document: { __typename?: 'Document', id: string, path: string, userId: string, context?: string | null, value: string, format?: string | null, formatValidation?: string | null, createdAt: any, updatedAt: any, documentHistory: Array<{ __typename?: 'DocumentHistory', id: string, value: any, documentId: string, createdAt: any }> } } };

export type UpsertPromptMutationVariables = Exact<{
  input: UpsertPromptInput;
}>;


export type UpsertPromptMutation = { __typename?: 'Mutation', upsertPrompt: { __typename?: 'UpsertPromptResponse', message: string, promptDefinition: { __typename?: 'PromptDefinition', id: string, value: string, createdAt: any, updatedAt: any } } };

export type GetAiAuditsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAiAuditsQuery = { __typename?: 'Query', aiAudits: Array<{ __typename?: 'AiAuditSummary', id: string, createdAt: any, endpoint: string, metadata?: any | null, prompt?: string | null, iteration?: number | null, maxIterations?: number | null, model?: string | null, instanceId?: string | null }> };

export type GetAiAuditFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiAuditFilterOptionsQuery = { __typename?: 'Query', aiAuditFilterOptions: { __typename?: 'AiAuditFilterOptions', endpoints: Array<string>, prompts: Array<string> } };

export type GetAiAuditByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAiAuditByIdQuery = { __typename?: 'Query', aiAudit?: { __typename?: 'AiAudit', id: string, createdAt: any, endpoint: string, metadata?: any | null, prompt?: string | null, iteration?: number | null, maxIterations?: number | null, model?: string | null, instanceId?: string | null, input: any, output: any } | null };

export type GetAppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppSettingsQuery = { __typename?: 'Query', appSettings: { __typename?: 'AppSettings', documentPathRegex: string, localEndpoints?: boolean | null, localDatabase?: boolean | null, aiAssistEditChatModels: Array<string>, defaultAiAssistEditChatModel: string } };

export type DocumentPickerListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentPickerListQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, path: string }> };

export type GetDocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDocumentQuery = { __typename?: 'Query', document: { __typename: 'Document', id: string, path: string, userId: string, context?: string | null, value: string, format?: string | null, formatValidation?: string | null, createdAt: any, updatedAt: any, documentHistory: Array<{ __typename?: 'DocumentHistory', id: string, value: any, documentId: string, createdAt: any }> } | { __typename: 'DocumentNotFound', requestedPath?: string | null } };

export type GetDocumentByPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type GetDocumentByPathQuery = { __typename?: 'Query', documentByPath: { __typename: 'Document', id: string, path: string, userId: string, context?: string | null, value: string, format?: string | null, formatValidation?: string | null, createdAt: any, updatedAt: any, documentHistory: Array<{ __typename?: 'DocumentHistory', id: string, value: any, documentId: string, createdAt: any }>, children: { __typename?: 'DocumentChildrenResponse', items: Array<{ __typename?: 'Document', id: string, path: string }>, pagination: { __typename?: 'PaginationInfo', hasMore: boolean } } } | { __typename: 'DocumentNotFound', requestedPath?: string | null, parent?: { __typename?: 'Document', id: string, path: string } | null, children: { __typename?: 'DocumentChildrenResponse', items: Array<{ __typename?: 'Document', id: string, path: string }>, pagination: { __typename?: 'PaginationInfo', hasMore: boolean } } } };

export type GetDocumentHistoryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDocumentHistoryQuery = { __typename?: 'Query', documentHistory?: { __typename?: 'DocumentHistory', id: string, value: any, documentId: string, createdAt: any } | null };

export type GetDocumentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, path: string, userId: string, context?: string | null, value: string, format?: string | null, formatValidation?: string | null, createdAt: any, updatedAt: any, documentHistory: Array<{ __typename?: 'DocumentHistory', id: string, value: any, documentId: string, createdAt: any }> }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'AuthUser', id: string, email: string, displayName: string, effectiveAiAssistEditChatModel: string, settings?: { __typename?: 'UserSettings', aiAssistEditChatModel?: string | null, colorMode?: string | null } | null } | null };

export type GetMessagesQueryVariables = Exact<{
  input?: InputMaybe<MessagesQueryInput>;
}>;


export type GetMessagesQuery = { __typename?: 'Query', messages: Array<{ __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, childMessages: Array<{ __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null, processorInstance?: { __typename?: 'ProcessorInstance', id: string } | null }> }>, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null, processorInstance?: { __typename?: 'ProcessorInstance', id: string } | null }> }> };

export type GetProcessorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProcessorQuery = { __typename?: 'Query', processor?: { __typename?: 'ProcessorDetail', id: string, fileId: string, createdAt: any, updatedAt: any, fileRefs: Array<{ __typename?: 'ProcessorFileRef', id: string, sortOrder: number, role: ProcessorFileRole }> } | null };

export type GetProcessorFileQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProcessorFileQuery = { __typename?: 'Query', processorFile?: { __typename?: 'ProcessorFileContent', id: string, code: string } | null };

export type GetProcessorInstanceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProcessorInstanceQuery = { __typename?: 'Query', processorInstance?: { __typename?: 'ProcessorInstance', id: string, processorId: string, userId: string, isActive: boolean, value?: any | null, error?: string | null, createdAt: any, updatedAt: any } | null };

export type GetProcessorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProcessorsQuery = { __typename?: 'Query', processors: { __typename?: 'GetProcessorsResponse', processors: Array<{ __typename?: 'Processor', id: string, fileId: string, createdAt: any, updatedAt: any }> } };

export type GetPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromptsQuery = { __typename?: 'Query', prompts: { __typename?: 'GetPromptsResponse', prompts: Array<{ __typename?: 'PromptDefinition', id: string, value: string, createdAt: any, updatedAt: any }> } };

export type GetUploadsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUploadsQuery = { __typename?: 'Query', uploads: Array<{ __typename?: 'UserUpload', id: string, resourceId: string, filename?: string | null, createdAt: any, url: string }> };
